import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Slider, Tooltip, Typography } from '@mui/material';
import { POINT_LABELS, POINT_OPTIONS } from '../constants';

function CommandModal({ open, onClose, idu, pointName, currentValue, onSubmit, loading }) {
  const [selected, setSelected] = useState(currentValue);

  useEffect(() => {
    setSelected(currentValue);
  }, [currentValue, pointName, open]);

  const isUnchanged = selected === currentValue;

  const handleSubmit = () => {
    if (selected === undefined || selected === null || isUnchanged) return;
    onSubmit({ iduDeviceId: idu.iduDeviceId, pointName, value: selected, vrvGatewayId: idu.vrvGatewayId });
  };

  const renderCurrentLabel = () => {
    if (pointName === 'SetTemperature') return `${currentValue}°C`;
    return POINT_LABELS[pointName]?.[currentValue] ?? currentValue;
  };

  const renderControl = () => {
    if (pointName === 'SetTemperature') {
      return (
        <div style={{ padding: '12px 4px 4px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 36, fontWeight: 700, color: '#2050ff', fontFamily: 'Manrope' }}>
              {selected}°C
            </span>
          </div>
          <Slider
            min={18}
            max={30}
            step={1}
            value={selected ?? 24}
            onChange={(_, v) => setSelected(v)}
            valueLabelDisplay="auto"
            sx={{
              color: '#2050ff',
              '& .MuiSlider-thumb': { width: 20, height: 20 },
              '& .MuiSlider-rail': { opacity: 0.3 },
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#aaa', fontFamily: 'Manrope', marginTop: 4 }}>
            <span>18°C</span>
            <span>30°C</span>
          </div>
        </div>
      );
    }

    const opts = POINT_OPTIONS[pointName] || [];
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, paddingTop: 12 }}>
        {opts.map(opt => {
          const isActive = selected === opt.value;
          return (
            <button
              key={opt.value}
              onClick={() => setSelected(opt.value)}
              style={{
                padding: '8px 18px',
                border: `2px solid ${isActive ? '#2050ff' : '#e5e7eb'}`,
                borderRadius: 8,
                background: isActive ? 'rgba(32,80,255,0.08)' : '#fff',
                color: isActive ? '#2050ff' : '#6b7280',
                fontWeight: isActive ? 700 : 500,
                cursor: 'pointer',
                fontFamily: 'Manrope',
                fontSize: 13,
                transition: 'all 0.15s',
                outline: 'none',
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: 14, fontFamily: 'Manrope' } }}
    >
      <DialogTitle sx={{ fontFamily: 'Manrope', fontWeight: 700, fontSize: 15, paddingBottom: 0 }}>
        {idu?.name || idu?.iduDeviceId}
        <span style={{ fontWeight: 400, color: '#9ca3af', marginLeft: 6, fontSize: 13 }}>
          · {pointName}
        </span>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: '8px !important' }}>
        <Typography variant="body2" sx={{ fontFamily: 'Manrope', color: '#9ca3af', marginBottom: 0.5 }}>
          Current: <strong style={{ color: '#374151' }}>{renderCurrentLabel()}</strong>
        </Typography>
        {renderControl()}
      </DialogContent>
      <DialogActions sx={{ padding: '12px 20px 16px' }}>
        <button
          onClick={onClose}
          style={{
            padding: '8px 20px',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            background: '#fff',
            color: '#6b7280',
            cursor: 'pointer',
            fontFamily: 'Manrope',
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          Cancel
        </button>
        <Tooltip placement='top' title={isUnchanged && `Select a different ${pointName} to enable command`} arrow>
          <span>
            <button
              onClick={handleSubmit}
              disabled={loading || selected === null || selected === undefined || isUnchanged}
              style={{
                padding: '8px 22px',
                border: 'none',
                borderRadius: 8,
                background: loading || isUnchanged ? '#93a3d8' : 'rgba(32,80,255,0.85)',
                color: '#fff',
                cursor: loading || isUnchanged ? 'not-allowed' : 'pointer',
                fontFamily: 'Manrope',
                fontSize: 13,
                fontWeight: 700,
                transition: 'background 0.2s',
              }}
            >
              {loading ? 'Sending…' : 'Send Command'}
            </button>
          </span>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
}

export default CommandModal;
